import type { TRuleWithTheme } from 'styles/theme';

export const filterPanel: TRuleWithTheme = ({ theme }) => ({
    backgroundColor: theme.colors.white,
    marginBottom: '1.5rem',
    borderRadius: 2,
});
